import React from 'react';
import { Link } from 'react-router';

import styles from './NavNotLoggedIn.css';

function NavNotLoggedIn(props) {
  const { location } = props;

  const signInStyle = location.pathname === '/login' ? { color: 'white' } : {};
  if (location.pathname === '/register-complete') {
    return <div />;
  }
  return (
    <div
      className={`navbar-collapse collapse header-login ${styles.wrapper}`}
      id="NavNotLoggedIn"
    >
      <ul
        className={`nav navbar-nav mk-navbar-nav navbar-right text-center ${styles['list-menu']}`}
      >
        <li>
          <a
            href="https://mokaposhelp.zendesk.com/hc/id"
            data-toggle="collapse"
            data-target=".navbar-collapse.in"
          >
            help
          </a>
        </li>
        <li>
          <Link
            to="/login"
            data-toggle="collapse"
            data-target=".navbar-collapse.in"
            style={signInStyle}
          >
            Sign In
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default NavNotLoggedIn;
